import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import PlayerRegistrationComponent from './js/player-registration.component';

ComponentsFactory.getInstance().define('player-registration', PlayerRegistrationComponent);
